import React, { Component } from 'react';
import { connect } from 'react-redux'
import { toggleIntro, loadMy, toggleCommentForm, updateCommentInput } from './actions/user'
import { createComment } from "./actions/post";
import {Icon, Form, Input, Checkbox, Button} from 'antd'
import {setDocumentHeight} from "./utils";
import pointx from './images/pointx.png'
import maskEmpty from './images/mask-empty.png'
import maskFill from './images/mask-fill.png'
import point1 from './images/point1.png'
import './CommentForm.css'
const FormItem = Form.Item
const TextArea = Input.TextArea

class CommentForm extends Component {

  componentDidMount(){
    if(!this.props.initial){
      this.props.loadMy()
    }
  }

  handleSubmit = (e) => {
    let {createComment, post} = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.form.resetFields()
        this.textarea.blur()
        createComment({...values, post})
      }
    });
  }

  handleAnonymous = (e) =>{
    let {updateCommentInput} = this.props
    updateCommentInput({
      anonymous: e.target.checked
    })
  }

  handleContent = (e) =>{
    let {updateCommentInput} = this.props
    updateCommentInput({
      content: e.target.value
    })
  }

  renderCommentForm(){
    const {toggleIntro, my, commentInput, toggleCommentForm, commentFormOpening } = this.props
    const {
      getFieldDecorator,
    } = this.props.form;
    return <div>
      <div className={"comment-form-header"} onClick={toggleCommentForm}>
        <Icon type={`${commentFormOpening?'minus':'plus'}`} style={{
          fontSize: 28,
          color: 'white',
          lineHeight: 1,
          height: 28,
          padding: 6
        }} className={"comment-form-add"}/>
        <div className={"comment-form-points"} style={{
          backgroundImage: `url(${pointx})`
        }}>
          {my.points || 0}
        </div>
      </div>
      <Form
        className={"comment-form-body"}
        onSubmit={this.handleSubmit}
      >
        <FormItem>
          {getFieldDecorator('content', {
            value: commentInput.content || '',
            rules: [{ required: true, message: '请输入讨论内容' }],
          })(
            <TextArea
              ref={ref=>{this.textarea=ref}}
              placeholder="参加讨论「+」"
              onChange={this.handleContent}
              onBlur={()=>{
                setDocumentHeight()
              }}
            />
          )}
        </FormItem>
        <FormItem
          className={"comment-form-anonymous"}
        >
          {getFieldDecorator('anonymous', {
            valuePropName: 'checked',
            value: commentInput.anonymous || false,
          })(
            <div>
              <Checkbox className={"anonymous-mask"}  style={{
                backgroundImage: `url(${commentInput.anonymous?maskFill:maskEmpty})`
              }} onChange={this.handleAnonymous}
              />
              <div className={'comment-form-cost'} style={{
                backgroundImage: `url(${point1})`
              }}>+1</div>
              <Icon type="question-circle" className={"comment-form-intro"}
                    onClick={toggleIntro}
              />
            </div>
          )}
        </FormItem>
        <FormItem
          className={"comment-form-send"}
        >
          <Button
            type="primary"
            htmlType="submit"
            className="comment-form-send-button"
          >发送</Button>
        </FormItem>
      </Form>
    </div>
  }

  render() {
    const {loadingMy, loadingMyError, commentFormOpening} = this.props
    return <div className={`comment-form-container ${commentFormOpening?'comment-form-open':'comment-form-closed'}`}>
      {
        loadingMy && <div className="comment-form-load-bar">
          <div className="comment-form-bar"></div>
          <div className="comment-form-bar"></div>
          <div className="comment-form-bar"></div>
        </div>
      }
      {
        loadingMyError && <div className={"loading-user-error"}>
          {loadingMyError}
        </div>
      }
      {
        (!loadingMy && !loadingMyError) && this.renderCommentForm()
      }
    </div>
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    my: state.user.my,
    initial: state.user.initial,
    commentInput: state.user.commentInput,
    loadingMy: state.user.loadingMy,
    loadingMyError: state.user.loadingMyError,
    commentFormOpening: state.user.commentFormOpening,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadMy: ()=>dispatch(loadMy()),
    toggleCommentForm: ()=>dispatch(toggleCommentForm()),
    createComment: (comment)=>dispatch(createComment(comment)),
    updateCommentInput: (comment)=>dispatch(updateCommentInput(comment)),
    toggleIntro: ()=>dispatch(toggleIntro())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(CommentForm))




// WEBPACK FOOTER //
// ./src/CommentForm.js